export default class GridTexsSortantController {
	/* @ngInject */
	constructor($state) {
		this.$state = $state;
	}

	async $init() {
		console.log('grid texs sortant initialized');
	}

	redirectToDAP(id) {
		let url = this.$state.href('daps.edit', { id: id });
		window.open('gestion.html' + url);
	}

	redirectToTicket(id) {
		let url = this.$state.href('tickets.detail', { id: id });
		window.open('gestion.html' + url);
	}
}
